module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_9.141497f9.jpeg";